import React, { Component } from "react";
import PropTypes from "prop-types";

import { orderBy, uniqBy, startCase } from "lodash";

import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";
import DropdownSearch from "../common/DropdownSearch";

class CodeForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = { canSubmit: false };
  }

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.editing && nextProps.code !== this.props.code) {
      this.setState({ entity: nextProps.code.entity });
    }
  };

  add = (model) => {
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.code._id;
    this.form.reset();
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { code, adding } = this.props;

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onChange={this.handleSelect}
      >
        <Row>
          <Col md={3}>
            <DropdownSearch
              required
              name="entity"
              label="Entity"
              onChange={this.onChange}
              value={this.state.entity || code.entity}
              data={orderBy(
                uniqBy(
                  [
                    ...this.props.codes.map((c) => ({
                      value: c.entity,
                      label: c.entity
                    }))
                  ],
                  "value"
                ),
                "value"
              )}
            />
          </Col>
          <Col md={3}>
            <DropdownSearch
              required
              name="field"
              label="Field"
              onChange={this.onChange}
              value={this.state.field || code.field}
              data={orderBy(
                uniqBy(
                  this.props.codes
                    .filter(
                      (codes) =>
                        codes.entity === code.entity ||
                        codes.entity === this.state.entity
                    )
                    .map((c) => {
                      const formattedField = c.field.replace(/[_-]/g, " ");
                      return {
                        value: c.field,
                        label: startCase(formattedField)
                      };
                    }),
                  "value"
                ),
                "value"
              )}
            />
          </Col>
          <Col md={2}>
            <Input
              name="value"
              label="Value"
              placeholder="Value"
              value={code.value || ""}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={2}>
            <Input
              name="label"
              label="Label"
              placeholder="Label"
              value={code.label || ""}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={2}>
            <Input
              name="order"
              type="number"
              label="Order"
              placeholder="Order"
              value={code.order || ""}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={12} className="footer">
            <button
              type="button"
              style={!adding ? { display: "inline" } : { display: "none" }}
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn  btn-success"
              type="submit"
              disabled={!this.state.canSubmit}
              value={`Sav${this.props.saving ? "ing..." : "e"}`}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

CodeForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  code: PropTypes.object.isRequired,
  codes: PropTypes.array.isRequired,
  onAdd: PropTypes.func,
  adding: PropTypes.bool,
  onCancel: PropTypes.func,
  editing: PropTypes.bool
};

export default CodeForm;
